import { SINGLE_API } from 'src/redux/actions/type';


export const createRestaurantGroup = (payload = {}, next, nextErr) => {
    return {
        type: SINGLE_API,
        payload: {
            opt: { method: 'POST' },
            uri: '/restaurant_groups',
            params: { ...payload },
            // beforeCallType: 'CREATE_RESTAURANT_REQUEST',
            // successType: 'CREATE_RESTAURANT_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const getListRestaurantGroup = (payload = {}, next, nextErr) => {
    const { params } = payload;
    return {
        type: SINGLE_API,
        payload: {
            uri: '/restaurant_groups',
            opt: {
                headers: {
                    Accept: 'application/ld+json'
                }
            },
            params,
            // beforeCallType: 'GET_RESTAURANT_LIST_REQUEST',
            // successType: 'GET_RESTAURANT_LIST_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};


export const getDetailRestaurantGroup = (payload, next, nextErr) => {
    // const { filter, firstLoad } = payload;
    const { id } = payload;
    return {
        type: SINGLE_API,
        payload: {
            uri: `/restaurant_groups/${id}`,
            // beforeCallType: 'GET_RESTAURANT_DETAIL_REQUEST',
            // successType: 'GET_RESTAURANT_DETAIL_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const getDetailRestaurantGroupByUserId = (payload, next, nextErr) => {
    // const { filter, firstLoad } = payload;
    const { user } = payload;
    return {
        type: SINGLE_API,
        payload: {
            uri: `/restaurant_groups`,
            // beforeCallType: 'GET_RESTAURANT_DETAIL_REQUEST',
            // successType: 'GET_RESTAURANT_DETAIL_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const editRestaurantGroup = (payload = {}, next, nextErr) => {
    const { id } = payload;
    return {
        type: SINGLE_API,
        payload: {
            opt: { method: 'PUT' },
            uri: `/restaurant_groups/${id}`,
            params: { ...payload },
            // beforeCallType: 'EDIT_RESTAURANT_REQUEST',
            // successType: 'EDIT_RESTAURANT_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};


export const getRestaurantGroupTransactionByCreditor = (payload = {}, next, nextErr) => {
    return {
        type: SINGLE_API,
        payload: {
            uri: `/transactions`,
            opt: {
                headers: {
                    Accept: 'application/ld+json'
                }
            },
            params: { ...payload },
            // beforeCallType: 'GET_RESTAURANT_LIST_REQUEST',
            // successType: 'GET_RESTAURANT_LIST_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const getRestaurantGroupRemboursementByRestaurant = (payload = {}, next, nextErr) => {
    return {
        type: SINGLE_API,
        payload: {
            uri: `/restaurant-refunds-by-id`,
            opt: {
                headers: {
                    Accept: 'application/ld+json'
                }
            },
            params: { ...payload },
            // beforeCallType: 'GET_RESTAURANT_LIST_REQUEST',
            // successType: 'GET_RESTAURANT_LIST_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const exportRestaurantGroupRemboursementByRestaurant = (payload = {}, next, nextErr) => {
    return {
        type: SINGLE_API,
        payload: {
            uri: `/export-restaurant-refunds-by-id`,
            opt: {
                headers: {
                    Accept: 'application/ld+json'
                }
            },
            params: { ...payload },
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const addRestaurantInGroup = (payload = {}, next, nextErr) => {
    const { id } = payload;
    return {
        type: SINGLE_API,
        payload: {
            opt: { method: 'PUT' },
            // uri: `/restaurant_groups/${id}/restaurant/add`,
            uri: `/restaurant_groups/${id}`,
            params: { ...payload },
            // beforeCallType: 'EDIT_RESTAURANT_REQUEST',
            // successType: 'EDIT_RESTAURANT_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const dissociatedRestaurantInGroup = (payload = {}, next, nextErr) => {
    const { id } = payload;
    return {
        type: SINGLE_API,
        payload: {
            opt: { method: 'PUT' },
            // uri: `/restaurant_groups/${id}/restaurant/add`,
            uri: `/restaurant_groups/${id}`,
            params: { ...payload },
            // beforeCallType: 'EDIT_RESTAURANT_REQUEST',
            // successType: 'EDIT_RESTAURANT_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};

export const getListRestaurant = (payload = {}, next, nextErr) => {
    // const { filter, firstLoad } = payload;
    const { params } = payload;
    return {
        type: SINGLE_API,
        payload: {
            uri: '/get-list-restaurants-not-in-group',
            opt: {
                headers: {
                    Accept: 'application/ld+json'
                }
            },
            params,
            beforeCallType: 'GET_RESTAURANT_LIST_REQUEST',
            successType: 'GET_RESTAURANT_LIST_SUCCESS',
            afterSuccess: next,
            afterError: nextErr
        }
    };
};